:<template>
  <header class="header">
    <div class="left">
      <img class="logo" alt="EMPIR" src="../assets/EMPIR-Euramet-Europe.jpg" />
    </div>
    <div class="right">
      <el-menu
        class="header-menu"
        :router="true"
        mode="horizontal">
        <el-menu-item index="1" route="/upload/list">Uploads</el-menu-item>
        <el-submenu index="2">
          <template slot="title">More</template>
          <el-menu-item index="2-1" route="/account">Edit account</el-menu-item>
          <el-menu-item index="2-2" @click="handleDisconnect">Disconnect</el-menu-item>
          <el-menu-item index="2-2" route="/about">About</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </header>
</template>

<script>

export default {
  name: 'Header',
  methods: {
    handleDisconnect(event) {
      const user = this.$cookies.get('user')
      delete user.accessToken
      delete user.id,
      delete user.tokenType
      user.manualDisconnection = true
      this.$cookies.set('user', user)
      window.location = '/'
      event.stopPropagation()
      event.preventDefault()
    },
  },
}
</script>
<style lang="scss">
@import "../themes.scss";

.header {
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  .left {
    flex: 1 1 auto;
    text-align: left;
    .logo {
      height: 60px;
    }
  }

  .right {
    flex: 0 0 auto;

    .header-menu {
      border-bottom: none!important;
    }
  }
}
</style>
